import React from 'react'
import styles from './Tabs.module.scss'

interface Tab {
    id: string
    label: React.ReactNode
    count?: number
}

interface TabsProps {
    tabs: Tab[]
    activeTab: string
    onTabChange: (tabId: string) => void
    children: React.ReactNode
}

/**
 * Tabs component for organizing content into switchable panels
 * 
 * @example
 * <Tabs
 *   tabs={[
 *     { id: 'history', label: 'History', count: 10 },
 *     { id: 'messages', label: 'Messages', count: 5 }
 *   ]}
 *   activeTab={activeTab}
 *   onTabChange={setActiveTab}
 * >
 *   {activeTab === 'history' && <HistoryContent />}
 *   {activeTab === 'messages' && <MessagesContent />}
 * </Tabs>
 */
export const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange, children }) => {
    return (
        <>
            <div className={styles.tabs}>
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''}`}
                        onClick={() => onTabChange(tab.id)}
                        type="button"
                    >
                        {tab.label}
                        {tab.count !== undefined && ` (${tab.count})`}
                    </button>
                ))}
            </div>
            <div className={styles.content}>
                {children}
            </div>
        </>
    )
}

